
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MAIN //

/**
* Tests if a 32-bit integer is odd.
*
* @param {integer32} x - value to test
* @returns {boolean} boolean indicating whether the value is odd
*
* @example
* var bool = isOdd( 5 );
* // returns true
*
* @example
* var bool = isOdd( -2 );
* // returns false
*
* @example
* var bool = isOdd( 0 );
* // returns false
*/
function isOdd( x ) {
	return (x & 1) === 1;
}


// EXPORTS //
export default isOdd;
